module.exports = __webpack_public_path__ + "ProximaNovaCond-Extrabld.woff?f0bf048f34f818c5fed5efa9eef4970d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNovaCond-Extrabld.woff
// module id = 43
// module chunks = 0